import { Component, OnInit, Input} from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { User } from '../../core/models/user.model';
import { Provider } from '../../core/models/provider.model';
import { Subject, Subscription, Observable } from 'rxjs';
import { PPAuthService } from '../../core/services/auth.service';
import { map, tap, filter, first} from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-consent-modal',
  templateUrl: './consent-modal.component.html',
  styleUrls: ['./consent-modal.component.scss'],
})
export class ConsentModalComponent implements OnInit {

  @Input() user: User;
  @Input() providerId: string;

  providerPromotionToggle = true;

  private providerPromotionToggleSub: Subscription;

  private providerSubscription: Subscription;
  private providerUserAlreadyExists = false;

  me$: Observable<User>;

  provider: Provider;

  constructor(  private http: HttpClient , private authService: PPAuthService, public toastController: ToastController, private modalCtrl: ModalController ) { 
      this.me$ = authService.me2$;
      console.log('aa');
  }

  getProvider$( providerId ) {

    const url = environment.apiUrl + '/providers/' + providerId;

    return this.http.get( url ).pipe(
       map ( response => new Provider( response ) )
    );

  }

  ngOnInit() {

    if ( this.user.providerUsers && this.user.providerUsers.length > 0 ) {

      for (let pu of this.user.providerUsers ) {

        if ( pu.provider && this.providerId == pu.provider.id ) {
          
         this.provider = pu.provider;
         this.providerUserAlreadyExists = true;

        } 

      }

    } 

    if ( !this.provider ) {

      this.providerSubscription = this.getProvider$( this.providerId ).subscribe( result => {
        console.log(result);
        this.provider = result;
      });

    }

  }

  ngOnDestroy() {

   if ( this.providerPromotionToggleSub ) {
     this.providerPromotionToggleSub.unsubscribe();
   }

   if ( this.providerSubscription ) {
     this.providerSubscription.unsubscribe();
   }
   
  }

  onCancel() {
    this.modalCtrl.dismiss( null, 'cancel' );
  }

  onSave( submitBtn: HTMLButtonElement ) {

    let ppt = this.providerPromotionToggle;

    let providerUserAlreadyExists = false;

    if ( this.user.providerUsers && this.user.providerUsers.length > 0 ) {

      for (let pu of this.user.providerUsers ) {

        if ( pu.provider && this.providerId == pu.provider.id ) {
          
          providerUserAlreadyExists = true

        } 

      }

    } 

    if ( !this.user.providerUsers || this.user.providerUsers.length == 0 || !providerUserAlreadyExists ) { //temp store to user

      this.providerPromotionToggleSub = this.authService.updateConsentToggleForMarketplace$( {
        'newsletterForNewProvider': this.providerPromotionToggle, 
        'promotionsViaSmsForNewProvider': this.providerPromotionToggle, 
        'promotionsViaEmailForNewProvider': this.providerPromotionToggle
      } ).subscribe( result => {
        this.modalCtrl.dismiss( null, 'saved' );
      } );

    } else {


      this.providerPromotionToggleSub = this.authService.updateConsentToggleForProvider$( this.providerId, {
      'newsletter': this.providerPromotionToggle, 
      'promotionsViaSms': this.providerPromotionToggle, 
      'promotionsViaEmail': this.providerPromotionToggle
      } ).subscribe( result => {
        this.modalCtrl.dismiss( null, 'saved' );
      } );

    }

    
    
  }

}
